import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAuthLayout = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(0, 0),
  flexDirection: 'column',
  flexGrow: 1,

  background:
    'radial-gradient(ellipse 80% 60% at 20% 10%, #172040 0%, #0a0c14 55%, #060810 100%)',
}));

export const StyledLogoContainer = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  backgroundColor: 'transparent',
  borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
  margin: 0,
  padding: '10px 80px',
});
